import { FC } from 'react'
import { default as ReactInlineSvg, Props as reactInlineSvgProps } from 'react-inlinesvg'

// Reference for below: https://stackoverflow.com/a/57832322/6417489
const HEIGHT_PARSE_REGEX = /^<svg[^>]*width\s*=\s*"?(\d+)"?[^>]*>/
const WIDTH_PARSE_REGEX = /^<svg[^>]*height\s*=\s*"?(\d+)"?[^>]*>/

export type SvgProps = Omit<reactInlineSvgProps, 'preProcessor'>

const Svg: FC<SvgProps> = ({ height = '100%', width = '100%', ...rest }) => {
  const handlePreprocess = (code: string) => {
    if (!code.includes('viewBox')) {
      const height = code.match(HEIGHT_PARSE_REGEX)?.[1]
      const width = code.match(WIDTH_PARSE_REGEX)?.[1]
      if (height && width) {
        // If no `viewBox` found and a height + width were parsed out of the svg, add
        // a `viewBox`. This will allow outside elements to better style the svg via
        // the `height` and `width` props.
        return code.replace(/^<svg/, `<svg viewBox="0 0 ${height} ${width}"`)
      }
    }
    return code
  }
  return <ReactInlineSvg height={height} width={width} preProcessor={handlePreprocess} {...rest} />
}

export default Svg
